module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_02_GhstIslnd.0e197d83.png";